import type { ModalProps } from '@heroui/modal';

/**
 * HeroUI modal defaults use fixed positioning vs the viewport. Studio portals into a preview node
 * marked `position: relative`, so overlays must use `absolute inset-0` to fill that frame only
 * (especially mobile/tablet bordered shells — not the inner scroll strip).
 */
export const studioPreviewPortalModalClassNames = {
  wrapper:
    '!absolute !inset-0 z-50 flex !h-full !max-h-full !min-h-0 !w-full !max-w-full overflow-hidden',
  backdrop: '!absolute !inset-0 z-40 !h-full !w-full !max-h-full !max-w-full',
  base: '!mx-0 !my-0 flex !h-full !max-h-full !min-h-0 !w-full !max-w-full !rounded-none shadow-none',
} satisfies NonNullable<ModalProps['classNames']>;

/** Centered dialog within the studio preview frame (e.g. product image gallery). */
export const studioPreviewPortalDialogClassNames = {
  wrapper:
    '!absolute !inset-0 z-50 flex !h-full !max-h-full !min-h-0 !w-full !max-w-full items-center justify-center overflow-hidden p-4',
  backdrop: '!absolute !inset-0 z-40 !h-full !w-full !max-h-full !max-w-full',
  base: '!mx-0 !my-0 flex !h-auto !max-h-full !min-h-0 !w-full !max-w-5xl flex-col overflow-hidden shadow-lg',
} satisfies NonNullable<ModalProps['classNames']>;

/** Bottom sheet within the studio preview frame (e.g. products sort). */
export const studioPreviewPortalBottomSheetClassNames = {
  wrapper:
    '!absolute !inset-0 z-50 flex !h-full !max-h-full !min-h-0 !w-full !max-w-full items-end justify-center overflow-hidden',
  backdrop: '!absolute !inset-0 z-40 !h-full !w-full !max-h-full !max-w-full',
  base: '!mx-0 !my-0 flex !h-auto !max-h-[85%] !min-h-0 !w-full !max-w-full flex-col overflow-hidden rounded-t-2xl',
} satisfies NonNullable<ModalProps['classNames']>;
